exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".banner-header[data-v-abd3eff6]{display:flex;align-items:center;justify-content:space-between;height:36px;background-color:#eee;font-size:16px;padding:8px 30px;margin-top:20px}.banner-main[data-v-abd3eff6]{box-sizing:border-box;width:640px;padding:20px}.card-wrap[data-v-abd3eff6]{box-sizing:border-box;width:100%;height:200px;overflow:auto;padding:10px;margin:8px 0 4px;border:1px solid #c0ccda;border-radius:4px;font-size:14px;line-height:1.5}.card-footer[data-v-abd3eff6]{text-align:right;font-size:14px;line-height:1.5}.upload__tip[data-v-abd3eff6]{font-size:12px;line-height:1.5}.dialog-item[data-v-abd3eff6]{display:inline-block;margin:0 4px 4px;padding:4px;border:1px solid #c0ccda;border-radius:4px;font-size:14px;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-abd3eff6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/banner/bannerDetail.vue
// module id = 615
// module chunks = 0